export const testimonialsData = [
  {
    id: 1,
    name: '岡山市在住 40代女性',
    title: '母の形見をリメイクして',
    content: '亡き母の指輪をペンダントにリメイクしていただきました。思い出を大切に残しながら、毎日身につけられる形にしてくださり、本当に感謝しています。職人さんの丁寧な仕事ぶりに感動しました。',
    rating: 5,
    avatar: 'https://public.readdy.ai/ai/img_res/6632ffa982981415442921822b94fa5c.jpg',
  },
  {
    id: 2,
    name: '倉敷市在住 30代男性',
    title: '婚約指輪をオーダーメイド',
    content: 'プロポーズのために婚約指輪をオーダーしました。彼女の好みを丁寧にヒアリングしてくださり、想像以上の素敵な指輪が完成しました。プロポーズも大成功で、今では夫婦の宝物です。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=handsome%20japanese%20man%20in%20his%2030s%20with%20gentle%20smile%20business%20casual%20style%20soft%20natural%20lighting%20cream%20background%20professional%20portrait%20photography%20warm%20expression%20sophisticated%20appearance&width=200&height=200&seq=testimonial2&orientation=squarish',
  },
  {
    id: 3,
    name: '岡山市在住 50代女性',
    title: '結婚30周年の記念に',
    content: '結婚30周年の記念に、夫婦でペアリングを作っていただきました。長年の想いを込めたデザインで、これからも一緒に歩んでいく決意を新たにできました。岡山でこんな素敵なお店に出会えて幸せです。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=graceful%20japanese%20woman%20in%20her%2050s%20with%20kind%20smile%20wearing%20elegant%20jewelry%20soft%20natural%20lighting%20cream%20background%20professional%20portrait%20photography%20mature%20beauty%20sophisticated%20style&width=200&height=200&seq=testimonial3&orientation=squarish',
  },
  {
    id: 4,
    name: '総社市在住 20代女性',
    title: '祖母からの贈り物をリメイク',
    content: '祖母から譲り受けたネックレスが古くなっていたので、リメイクをお願いしました。現代的なデザインに生まれ変わり、普段使いできるようになりました。祖母の想いを受け継ぎながら、新しい形で大切にできることが嬉しいです。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=beautiful%20young%20japanese%20woman%20in%20her%2020s%20with%20bright%20smile%20wearing%20delicate%20jewelry%20soft%20natural%20lighting%20cream%20background%20professional%20portrait%20photography%20youthful%20elegance%20natural%20beauty&width=200&height=200&seq=testimonial4&orientation=squarish',
  },
];